import { render, staticRenderFns } from "./Question.vue?vue&type=template&id=e33115a4&scoped=true"
import script from "./Question.vue?vue&type=script&lang=ts"
export * from "./Question.vue?vue&type=script&lang=ts"
import style0 from "./Question.vue?vue&type=style&index=0&id=e33115a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e33115a4",
  null
  
)

export default component.exports